import { z } from "zod";

export const addressStepFormSchema = z.object({
  address: z.object({
    postalCode: z
      .string({ message: "Obrigatório" })
      .min(8, "CEP deve conter 8 dígitos"),
    country: z.string({ message: "Obrigatório" }).min(1, "Obrigatório"),
    stateCode: z.string({ message: "Obrigatório" }).min(1, "Obrigatório"),
    city: z.string({ message: "Obrigatório" }).min(1, "Obrigatório"),
    neighbourhood: z.string({ message: "Obrigatório" }).min(1, "Obrigatório"),
    street: z.string({ message: "Obrigatório" }).min(1, "Obrigatório"),
    number: z.string({ message: "Obrigatório" }).min(1, "Obrigatório"),
    complement: z.string().optional(),
  }),
});

export type AddressStepFormValues = z.infer<typeof addressStepFormSchema>;
